module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-panel product",
    class: _vm.headerClass
  }, [_vm._t("panel-section"), _vm._v(" "), (_vm.title || _vm.$slots.extras) ? _c('header', {
    staticClass: "c-panel__header",
    class: {
      onlyHeader: (!_vm.withBody && !_vm.withFooter) || !_vm.show
    },
    on: {
      "click": _vm.toggleVariationInfo
    }
  }, [_c('div', {
    class: _vm.titleCustomClass
  }, [(_vm.onClick) ? _c('span', {
    staticClass: "check-box",
    class: _vm.selectClass,
    on: {
      "click": _vm.select
    }
  }) : _vm._t("header-left"), _vm._v(" "), _c('h2', {
    staticClass: "c-panel__title v-middle"
  }, [(!_vm.to && _vm.useAcordion && _vm.titleChangeble) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : (!_vm.to && _vm.useAcordion && !_vm.titleChangeble) ? _vm._m(0) : (!_vm.to) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }) : _c('router-link', {
    staticClass: "hint hint--right",
    attrs: {
      "to": _vm.to,
      "data-label": "Clique aqui para acessar"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })], 1)], 2), _vm._v(" "), (_vm.useToggleIcon) ? _c('i', {
    staticClass: "u-floatRight icon-toggle",
    class: _vm.toggleIconClass
  }) : _vm._e(), _vm._v(" "), _vm._t("header-right")], 2) : _vm._e(), _vm._v(" "), (_vm.withBody) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "c-panel__body"
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.footer && _vm.withFooter) ? _c('footer', {
    staticClass: "c-panel__footer"
  }, [_vm._t("footer")], 2) : _vm._e(), _vm._v(" "), _vm._t("floor")], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31734d9e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/Panel.vue
// module id = 3031
// module chunks = 0